import {
  MDBBtn,
  MDBCol,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBRow,
  MDBSelect,
} from "mdbreact";
import React from "react";
import { useDispatch } from "react-redux";
import {
  showHideLoader,
  showNotification,
  toggleModal,
} from "../../../../actions";
import { useState } from "react";
import { useEffect } from "react";
import {
  createNotificationTemplate,
  getNotificationEventTypes,
  getNotificationTypes,
  updateNotificationTemplate,
} from "../../../../apis/NotificationTemplateApi";
import { clearError } from "../../../../helper/ValidationHelper";
import SmsEditor from "./SmsEditor";
import EmailHtmlEditor from "./EmailHtmlEditor";
import { minifyHtml } from "./EmailHtmlHelper";

function NotificationTemplateModal({
  showModal,
  onClose,
  templateData,
  isEdit,
}) {
  const dispatch = useDispatch();

  const [templatePayload, setTemplatePayload] = useState(() => ({
    ...templateData,
  }));
  const [templatePayloadError, setTemplatePayloadError] = useState({});
  const [notificationEventTypeOptions, setNotificationEventTypeOptions] =
    useState([]);
  const [notificationTypeOptions, setNotificationTypeOptions] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [editorType, setEditorType] = useState(2);

  const handleNotificationTypeOptions = (isCheck, template) => {
    if (template) {
      if (template.eventTypeId) {
        if (notificationEventTypeOptions) {
          const atIndex = notificationEventTypeOptions.findIndex(
            (types) => types.value === template.eventTypeId.toString(),
          );
          notificationEventTypeOptions[atIndex].checked = isCheck;
        }
      }
      if (template.typeId) {
        setEditorType(template.typeId);
        if (notificationTypeOptions) {
          const atIndex = notificationTypeOptions.findIndex(
            (types) => types.value === template.typeId.toString(),
          );
          notificationTypeOptions[atIndex].checked = isCheck;
        }
      }
    }
  };

  const handleClose = () => {
    onClose();
    dispatch(toggleModal({ isOpen: false }));
    setTemplatePayload({});
    handleNotificationTypeOptions(false, templatePayload);
    setTemplatePayloadError({});
    setEditorType(2);
  };

  const handleValidation = () => {
    const nextErrors = {};
    if (!templatePayload.eventTypeId) {
      nextErrors.eventTypeId = "Event type is requireed. Select a Event Type";
    }
    if (!templatePayload.typeId) {
      nextErrors.typeId = "Type is reqired. Select a Type";
    }
    if (!templatePayload.template) {
      nextErrors.template = "Template is required";
    }
    setTemplatePayloadError(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const utf8ToBase64 = (str) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);

    const binaryString = String.fromCharCode.apply(null, data);
    return btoa(binaryString);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!handleValidation()) return;
    setSubmitting(true);
    dispatch(showHideLoader(true));
    try {
      const payload = {
        eventTypeId: Number(templatePayload.eventTypeId),
        typeId: Number(templatePayload.typeId),
        subject: templatePayload.subject,
        template: utf8ToBase64(minifyHtml(templatePayload.template)),
      };
      let response;
      if (isEdit) {
        response = await updateNotificationTemplate(
          templatePayload.id,
          payload,
        );
      } else {
        response = await createNotificationTemplate(payload);
      }
      dispatch(showNotification("success", response.data.message));
    } catch (error) {
      let action = isEdit ? "update" : "create";
      let message = "Failed to " + action + " template";
      if (!error || !error.data) {
        console.log(error);
      } else {
        console.log(error.data.message);
      }
      dispatch(showNotification("error", message));
    } finally {
      setSubmitting(false);
      dispatch(showHideLoader(false));
      handleClose();
    }
  };
  useEffect(() => {
    if (showModal && templateData) {
      setTemplatePayload({ ...templateData });
      handleNotificationTypeOptions(true, templateData);
    }
  }, [showModal, templateData, isEdit]);

  useEffect(() => {
    getNotificationEventTypes().then((res) => {
      const eventTypes = res.data.data;
      const eventTypeOptions = [];
      for (const eventType of eventTypes) {
        const option = {
          text: eventType.name,
          value: eventType.id.toString(),
          checked: false,
        };
        eventTypeOptions.push(option);
      }
      setNotificationEventTypeOptions(eventTypeOptions);
    });
    getNotificationTypes().then((res) => {
      const types = res.data.data;
      const typeOptions = [];
      for (const notificationType of types) {
        const option = {
          text: notificationType.name,
          value: notificationType.id.toString(),
          checked: false,
        };
        typeOptions.push(option);
      }
      setNotificationTypeOptions(typeOptions);
    });
  }, []);

  const handleSmsOnChange = (val) => {
    setTemplatePayload((payload) => ({
      ...payload,
      template: val,
    }));
    setTemplatePayloadError((prev) => clearError(prev, "template"));
  };

  const handleEmailTemplateOnChange = (val) => {
    if (!val) return;
    setTemplatePayload((payload) => ({
      ...payload,
      template: val,
    }));
    setTemplatePayloadError((prev) => clearError(prev, "template"));
  };

  return (
    <>
      <div className="child-popup">
        <MDBModal isOpen={showModal} size="xl" toggle={() => handleClose()}>
          <MDBModalHeader>
            {isEdit
              ? "Modify Notification Template"
              : "Create New Notification Template"}
          </MDBModalHeader>
          <form onSubmit={handleSubmit}>
            <MDBModalBody
              style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
            >
              <MDBRow className="md-2">
                <MDBCol md="6">
                  <label htmlFor="types" className="grey-text">
                    <span className="text-danger">*</span> Types
                  </label>

                  {templatePayloadError.typeId && (
                    <small
                      className="text-danger"
                      style={{ marginLeft: "10px" }}
                    >
                      {templatePayloadError.typeId}
                    </small>
                  )}
                  <MDBSelect
                    outline
                    color="primary"
                    options={notificationTypeOptions}
                    id="types"
                    getValue={(val) => {
                      if (!val && val.length <= 0) return;
                      setTemplatePayload((payload) => ({
                        ...payload,
                        typeId: val[0],
                      }));
                      setTemplatePayloadError((prev) =>
                        clearError(prev, "typeId"),
                      );
                      setEditorType(val[0]);
                    }}
                  />
                </MDBCol>
                <MDBCol md="6">
                  <label htmlFor="event_type" className="grey-text">
                    <span className="text-danger">*</span> Event Types
                  </label>
                  {templatePayloadError.eventTypeId && (
                    <small
                      className="text-danger"
                      style={{ marginLeft: "10px" }}
                    >
                      {templatePayloadError.eventTypeId}
                    </small>
                  )}
                  <MDBSelect
                    outline
                    color="primary"
                    options={notificationEventTypeOptions}
                    id="event_type"
                    getValue={(val) => {
                      if (!val && val.length <= 0) return;
                      setTemplatePayload((payload) => ({
                        ...payload,
                        eventTypeId: val[0],
                      }));
                      setTemplatePayloadError((prev) =>
                        clearError(prev, "eventTypeId"),
                      );
                    }}
                  />
                </MDBCol>
              </MDBRow>
              <MDBRow className="md-2">
                <MDBCol className="md-12">
                  <label htmlFor="subject" className="grey-text">
                    Subject
                  </label>
                  <MDBInput
                    id="subject"
                    outline
                    type="text"
                    value={templatePayload.subject}
                    onChange={(e) => {
                      e.persist();

                      setTemplatePayload((payload) => ({
                        ...payload,
                        subject: e.target.value,
                      }));
                    }}
                  />
                </MDBCol>
              </MDBRow>
              <MDBRow className="md-2">
                <MDBCol md="12">
                  <label htmlFor="template" className="grey-text">
                    <span className="text-danger">*</span> Template
                  </label>
                  {templatePayloadError.template && (
                    <small
                      className="text-danger"
                      style={{ marginLeft: "10px" }}
                    >
                      {templatePayloadError.template}
                    </small>
                  )}
                  {editorType == 1 ? (
                    <SmsEditor
                      onChange={handleSmsOnChange}
                      value={templatePayload.template}
                    />
                  ) : (
                    <div style={{ minHeight: "500px" }}>
                      <EmailHtmlEditor
                        handleOnChange={handleEmailTemplateOnChange}
                        initialHtml={templatePayload.template}
                      />
                    </div>
                  )}
                </MDBCol>
              </MDBRow>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn type="submit" disabled={submitting} color="primary">
                {submitting ? "Saving..." : "Submit"}
              </MDBBtn>
              <MDBBtn color="secondary" onClick={() => handleClose()}>
                Close
              </MDBBtn>
            </MDBModalFooter>
          </form>
        </MDBModal>
      </div>
    </>
  );
}

export default NotificationTemplateModal;
